import React, { useLayoutEffect, useRef } from "react";
import PropTypes from "prop-types";

const oneXTypeClasses = {
  primary: "-oneX-btn-primary",
  secondary: "-oneX-btn-secondary",
  ghost: "-oneX-btn-ghost",
};

const oneXButtonSizes = {
  small: "-oneX-btn-small",
  medium: "-oneX-btn-medium",
  large: "-oneX-btn-large",
};

const OneXButton = ({ id, children, type, clickHandler, onKeyPress, disabled, className, size, buttonStyle, paddingBottom }) => {
  const wrapperRef = useRef(null);

  useLayoutEffect(() => {

    const currentRef = wrapperRef.current;

    window.oneX.addElement(currentRef);

    return () => {
      window.oneX.removeElement(currentRef);
    }

  }, []); 

  return (
    <div id={id} ref={wrapperRef} style={{ paddingBottom: paddingBottom }}>
      <button
        type={"button"}
        className={`${oneXTypeClasses[type]} ${oneXButtonSizes[size]} -oneX-btn-fit-content`.trim()}
        onMouseDown={clickHandler}
        onKeyPress={onKeyPress}
        disabled={disabled}
        style={buttonStyle}
      >
        {children}
      </button>
    </div>
  );
};

export default OneXButton;

OneXButton.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
  type: PropTypes.oneOf(Object.keys(oneXTypeClasses)),
  clickHandler: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(oneXButtonSizes)),
  buttonStyle: PropTypes.any,
  paddingBottom: PropTypes.any,
};

OneXButton.defaultProps = {
  children: "Click",
  type: "primary",
  clickHandler: () => console.log(`Empty click handler.`),
  disabled: false,
  size: "large",
  paddingBottom: "16px",
};
